module.exports = __webpack_public_path__ + "assets/img/welcome.e927a5f1.png";